import { ETenant } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const ITenantsTagType = 'advanced-tenants';

export interface ITenantsTag {
  type: 'advanced-tenants';
  value: ETenant;
}

function isTenantsTag(tag: TTag): tag is ITenantsTag {
  return tag.type === ITenantsTagType;
}

export const tenantsTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.composition && jsonQuery.composition.value;

    let nextTags = tags.filter(
      tag => tag.type !== ITenantsTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: ETenant) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is ITenantsTag => isTenantsTag(tag) && tag.value === value,
            () => ({ type: ITenantsTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
